import "../static files/styles/navbar.css";
import instagram from "../static files/images/Instagram-Logo-PNG-Free-Download.png";
import facebook from "../static files/images/facebook-logo-facebook-social-media-icon-free-png.png";
import whatsapp from "../static files/images/WhatsApp-Logo.wine.png";
import { Navigate, NavLink, useNavigate } from "react-router-dom";
import logo from "../static files/images/transparent.png";
import { useDispatch } from "react-redux";
import { userProductShow } from "../slices/productReducer";
import support from "../static files/images/Support.png";
import window from "../static files/images/window.png";

const Footer = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const categories = [
    {
      id: 1,
      name: "Pəncərə sistemləri",
      subcategories: [
        { name: "Veka pəncərələri", slug: "veka-pencereleri" },
        { name: "Alüminium izosistem", slug: "aluminium-izosistem" },
        { name: "Hebe Schiebe", slug: "hebe-schiebe" },
        { name: "Taxta pəncərələr", slug: "taxta-pencereler" },
        { name: "Şəbəkə (Karolaj)", slug: "sebeke-karolaj" },
        { name: "Giyotin pəncərələr", slug: "giyotin-pencereler" },
      ],
    },
    {
      id: 2,
      name: "Metal Konstruksiya",
      subcategories: [
        { name: "Anbarlar", slug: "anbarlar" },
        { name: "Metal söhbətgah", slug: "metal-sohbetgah" },
        { name: "Pilləkən", slug: "pilleken" },
        { name: "Məhəccər", slug: "meheccer" },
        { name: "Loft Soft", slug: "loft-soft" },
        { name: "Avtomatik qapılar", slug: "avtomatik-qapilar" },
      ],
    },
    {
      id: 3,
      name: "Fasad sistemləri",
      subcategories: [
        { name: "Şüşə fasad (cəbhə)", slug: "suse-fasad-cebhe" },
        {
          name: "Alüminium kompozit panel (Alkopon)",
          slug: "aluminium-kompozit-panel-alkopon",
        },
      ],
    },
    {
      id: 4,
      name: "Məhəccər",
      subcategories: [
        { name: "Tökmə alüminium", slug: "tokme-aluminium" },
        { name: "Şüşə məhəccər", slug: "suse-meheccer" },
        { name: "Metal məhəccər", slug: "metal-meheccer" },
      ],
    },
    {
      id: 5,
      name: "Digər",
      subcategories: [
        { name: "Tent-perqola", slug: "tent-perqola" },
        { name: "İzolyasiya sistemləri", slug: "izolasiya-sistemleri" },
        { name: "Ağcaqanad torları", slug: "agcaqanad-torlari" },
        { name: "Cambalkon", slug: "cambalkon" },
        { name: "Qış bağçaları", slug: "qis-bagcalari" },
      ],
    },
  ];

  const handleSubcategoryClick = async (subcategory) => {
    // dispatch thunk ilə API-dan məlumat al
    await dispatch(userProductShow(subcategory.slug));
    // details səhifəsinə yönləndir
    navigate(`/details/${subcategory.slug}`);
  };
  return (
    <>
      <div className="contact-front-footer">
        <div>
          <img className="window-img" src={window} alt="window" />
          <h2>Xidmətlərlə bağlı sualınız var ? Bizlə əlaqəyə keçin.</h2>
        </div>
        <NavLink to={"/contact"}>
          Əlaqə
          <img className="support-img" src={support} alt="support" />
        </NavLink>
      </div>
      <footer>
        <div className="footer-line"></div>
        <div className="sections">
          <div className="section-one">
            <div className="mail-div">
              <article className="mail-phone">
                <a
                  style={{ textDecoration: "none" }}
                  href="mailto:info@azglassgroup.az"
                >
                  info@azglassgroup.az
                </a>
                <a style={{ textDecoration: "none" }} href="tel:+994502562211">
                  +994 (50) 256 22 11
                </a>
                <a style={{ textDecoration: "none" }} href="tel:+994502562211">
                  +994 (70) 256 22 11
                </a>
              </article>
              <article className="social-media">
                <h3>Bizi izləyin.</h3>
                <ul>
                  <li>
                    <a
                      href="https://wa.me/502562211"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="image-box"
                    >
                      <img src={whatsapp} alt="tiktok" />
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://instagram.com/azglassgroup.az"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="image-box"
                    >
                      <img src={instagram} alt="instagram" />
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://facebook.com"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="image-box"
                    >
                      <img src={facebook} alt="linkedin" />
                    </a>
                  </li>
                </ul>
              </article>
            </div>

            <article className="copy">
              <NavLink to={"/"} className="logo-box">
                <img className="logo-nav" src={logo} alt="logo" />
                <div className="texts">
                  <h2>AzGlass Design</h2>
                  <h3>Group Construction</h3>
                </div>
              </NavLink>
              <h4>Copyright © 2025 AzGlass Design. All rights reserved.</h4>
            </article>
          </div>
          <div className="section-two">
            <ul className="footer-list">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <div className="burger-cat">
                    <div className="name">
                      <a
                        href="#"
                        style={{
                          transition: "color 0.3s ease",
                        }}
                      >
                        {cat.name}
                      </a>
                      <div
                        className="line"
                        style={{
                          transition: "width 0.3s ease",
                        }}
                      ></div>
                    </div>
                  </div>
                  <div className="burger-subcategories">
                    {cat.subcategories.map((sub, idx) => (
                      <a
                        href="#"
                        key={idx}
                        onClick={(e) => {
                          e.preventDefault();
                          handleSubcategoryClick(sub);
                        }}
                      >
                        {sub.name}
                      </a>
                    ))}
                  </div>
                </li>
              ))}
              <li>
                <div className="burger-cat">
                  <div className="name">
                    <a
                      href="#"
                      style={{
                        transition: "color 0.3s ease",
                      }}
                    >
                      Keçidlər
                    </a>
                    <div
                      className="line"
                      style={{
                        transition: "width 0.3s ease",
                      }}
                    ></div>
                  </div>
                </div>
                <div className="burger-subcategories">
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/about");
                    }}
                  >
                    Haqqımızda
                  </a>
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/contact");
                    }}
                  >
                    Bizimlə əlaqə
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
